import React, { useState } from "react";
import FormikSelectTwo from "../../../../../Components/Utils/Select";
import EditIcon from "../../../../../Components/Icons/Edit";
import DeleteIcon from "../../../../../Components/Icons/Delete";
import { formatDisplaySno } from "../../../../../Components/Utils/formatDisplaySno";
// import FormikSelectTwo from "../../../../Components/Utils/Select";
// import DeleteIcon from "../../../../Components/Icons/Delete";
// import EditIcon from "../../../../Components/Icons/Edit";

export default function RFQProductTable({
  prlist,
  error,
  formik,
  deletedItemDropDown,
  onAddProduct,
  onQuantityChange,
  onDeleteItem,
}) {
  const [isEditQua, setIsEditQua] = useState(false);

  return (
    <div className="w-full">
      {deletedItemDropDown && deletedItemDropDown.length > 0 ? (
        <div className="w-full flex justify-start gap-2">
          <FormikSelectTwo
            type="text"
            label="Product"
            placeholder="Product"
            Options={deletedItemDropDown}
            formik={formik}
            name="productId"
            width="w-full md:w-1/2 lg:w-[67%]"
          />
          <button
            onClick={onAddProduct}
            type="button"
            className="p-1 mt-[44px] m-1 text-center h-8 cursor-pointer bg-[#048178] border border-solid border-white text-xs font-medium text-white rounded-lg"
          >
            Add
          </button>
        </div>
      ) : null}

      <div className="w-full bg-white overflow-auto">
        {error && (
          <p className="text-xs font-semibold text-red-500 mb-2">{error}</p>
        )}
        <div className="w-full min-w-[600px] py-2 bg-[#048178] flex justify-between rounded-lg px-6">
          <p className="w-[5%] text-left text-white text-xs font-medium">S.No</p>
          <p className="w-[60%] text-left text-white text-xs font-medium">Product</p>
          <p className="w-[10%] text-center text-white text-xs font-medium">Unit</p>
          <p className="w-[20%] text-center text-white text-xs font-medium flex justify-center">
            Quantity
            <span
              className="pl-1 cursor-pointer"
              onClick={() => setIsEditQua((prv) => !prv)}
            >
              <EditIcon width={"14"} height={"14"} color={isEditQua ? "yellow" : undefined} />
            </span>
          </p>
          <p className="w-[5%] text-center text-white text-xs font-medium">Action</p>
        </div>

        {prlist?.length > 0 ? (
          <div className="h-[calc(100vh-300px)] min-w-[600px] overflow-auto">
            {formatDisplaySno(prlist || []).map((item, index) => (
              <div
                key={index}
                className="w-full py-2 flex justify-between px-6 odd:bg-white even:bg-slate-100"
              >
                <p className="w-[5%] text-left text-xs font-medium text-[#111537] py-1">
                  {item?.display_sno || index + 1}
                </p>
                <p className="w-[60%] text-left text-xs font-medium text-[#111537]">
                  {item?.product_name}
                </p>
                <p className="w-[10%] text-center text-xs font-medium text-[#111537]">
                  {item?.product_unit}
                </p>
                <p className="w-[20%] text-center text-xs font-medium text-[#111537]">
                  <input
                    type="number"
                    className="w-full outline-none text-center"
                    name="quantity"
                    value={item?.quantity || ""}
                    disabled={!isEditQua}
                    onChange={(e) => onQuantityChange(e, index)}
                  />
                </p>
                <div className="w-[5%] text-center">
                  <button
                    onClick={() => onDeleteItem(index)}
                    type="button"
                    className="text-red-500 cursor-pointer ml-4 border-none"
                  >
                    <DeleteIcon color="red" height={4} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="w-full text-center text-[#93949f] py-4">No Items here</div>
        )}
      </div>
    </div>
  );
}
